import PropTypes from 'prop-types'
import { Component } from 'react'
import FontAwesome from 'react-fontawesome'
import './styles.scss'

export class IconCheck extends Component {
  constructor (props) {
    super(props)
    this.handleChange = this.handleChange.bind(this)
    this.selectClassName = this.selectClassName.bind(this)
  }

  handleChange () {
    const { disabled, onCheck, checked } = this.props
    if (!disabled) {
      onCheck(null, !checked)
    }
  }

  selectClassName () {
    const { uncheckedIcon } = this.props
    if (uncheckedIcon && uncheckedIcon.includes('star')) {
      return 'nh-star'
    }
    return ''
  }

  render () {
    const { label, uncheckedIcon, checkedIcon, checked, disabled } = this.props
    return (
      <div
        className='nh-icon-check-container'
        onClick={this.handleChange}
        aria-hidden='true'
      >
        <input
          type='checkbox'
          defaultChecked={checked || false}
          value={label}
          disabled={disabled}
        />
        <FontAwesome
          name={checked ? checkedIcon : uncheckedIcon}
          size='lg'
          className={`nh-icon-check ${
            disabled ? 'disabled' : ''
          } ${this.selectClassName()}`}
        />
      </div>
    )
  }
}

IconCheck.propTypes = {
  onCheck: PropTypes.func.isRequired,
  uncheckedIcon: PropTypes.string.isRequired,
  checkedIcon: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  label: PropTypes.string
}
